import type { JSX } from 'react';
import { useMemo, useState } from 'react';

import type { MyPlanCardDto } from '../../lib/api/openingTasks';
import { useViewAsReadOnly } from '../opening-tasks/useViewAsReadOnly';
import { checklistTasks, groupPlanTasks, isPlanReadOnly, matchesSide, PLAN_COPY, type PlanMode, type SideFilter } from './plan-model';
import { PlanTaskGroups, SideChips } from './PlanTaskGroups';

/**
 * Вкладка «Чеклисты»: задачи плана, у которых есть чек-лист, по этапам; каждая раскрыта сразу. Фильтр «Мои | УК |
 * Все». Пункты отмечаются здесь же (кроме задач УК — их партнёр только смотрит); у менеджера (`mode="manager"`)
 * отметок нет совсем.
 */
export function PlanChecklistsTab({ card, mode = 'partner' }: { card: MyPlanCardDto; mode?: PlanMode }): JSX.Element {
  const readOnly = isPlanReadOnly(useViewAsReadOnly(), mode);
  const [side, setSide] = useState<SideFilter>('mine');
  const withLists = useMemo(() => checklistTasks(card.tasks), [card.tasks]);
  const groups = useMemo(() => groupPlanTasks(card.stages, withLists, { side, status: 'all', stage: null }), [card.stages, withLists, side]);
  const counts: Record<SideFilter, number> = {
    mine: withLists.filter((t) => matchesSide(t, 'mine')).length,
    uk: withLists.filter((t) => matchesSide(t, 'uk')).length,
    all: withLists.length,
  };

  return (
    <div className="fk-op-panel">
      {withLists.length === 0 ? (
        <div className="fk-op-card">
          <div className="fk-ot-empty">{PLAN_COPY[mode].noChecklists}</div>
        </div>
      ) : (
        <>
          <div className="fk-op-filters">
            <SideChips value={side} onChange={setSide} counts={counts} mode={mode} />
          </div>
          {groups.length === 0 ? (
            <div className="fk-op-card">
              <div className="fk-ot-empty">С выбранной стороны чек-листов нет — переключите фильтр.</div>
            </div>
          ) : (
            <PlanTaskGroups groups={groups} readOnly={readOnly} defaultOpen />
          )}
        </>
      )}
    </div>
  );
}
